import React from 'react'
import { InputContainer } from '../../../../../common/components/form/form.module';

export default function ModalOneMembershipComponent({ Close
    , mentors, handleItemSubmit, selectedPlans, onInnerModalFormChange }: any) {


    return (

        <div className="  w-full p-2 bg-white shadow-md rounded-md">
            <h1 className="text-xl font-bold mb-4 text-center">Add One Membership</h1>
            <div className=" grid md:grid-cols-2 lg:grid-cols-2 gap-4 border p-4">
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerModalFormChange(
                            event.target.value,
                            'Name',

                        )
                    }}
                    type="text"
                    value={selectedPlans?.Name}
                />

                <InputContainer
                    label="Description"
                    name="Description"
                    onValueChange={(event: any) => {
                        onInnerModalFormChange(
                            event.target.value,
                            'Description',

                        )
                    }}
                    type="text"
                    value={selectedPlans?.Description}
                />

                <InputContainer
                    label="Duration"
                    name="Duration"
                    onValueChange={(event: any) => {
                        onInnerModalFormChange(
                            event.target.value,
                            'Duration',

                        )
                    }}
                    type="text"
                    value={selectedPlans?.Duration}
                />


                <InputContainer
                    label="Enable"
                    name="IsEnabled"
                    onValueChange={(event: any) => {
                        onInnerModalFormChange(
                            event,
                            'IsEnabled'
                        )
                    }}
                    type="checkbox"
                    value={selectedPlans?.IsEnabled}
                />

                <InputContainer
                    label="Free Cost"
                    name="IsFreeOfCost"
                    onValueChange={(event: any) => {
                        onInnerModalFormChange(
                            event,
                            'IsFreeOfCost'
                        )
                    }}
                    type="checkbox"
                    value={selectedPlans?.IsFreeOfCost}
                />

                {!selectedPlans?.IsFreeOfCost && (
                    <InputContainer
                        label="Price"
                        name="Price"
                        onValueChange={(event: any) => {
                            onInnerModalFormChange(
                                event.target.value,
                                'Price',
                            );
                        }}
                        type="number"
                        value={selectedPlans?.Price}
                    />
                )}

                <div className='col-span-full'>
                    <InputContainer
                        label="Services"
                        name="IncludedServices"
                        onValueChange={(event: any) => {
                            onInnerModalFormChange(
                                event,
                                'IncludedServices',
                            )
                        }}
                        type="rte"
                        value={selectedPlans?.IncludedServices}
                    />
                </div>


                <div className='col-span-full'>

                    <InputContainer
                        label="Specifications"
                        name="Specifications"
                        onValueChange={(event: any) => {
                            onInnerModalFormChange(
                                event,
                                'Specifications',
                            )
                        }}
                        type="rte"
                        value={selectedPlans?.Specifications}
                    />
                </div>

                <InputContainer
                    label="Start Date"
                    name="StartDateUtc"
                    onValueChange={(event: any) => {
                        onInnerModalFormChange(
                            event.target.value,
                            'StartDateUtc'
                        )
                    }}
                    type="date"
                    value={selectedPlans?.StartDateUtc}
                />

                <InputContainer
                    label="End Date"
                    name="EndDateUtc"
                    onValueChange={(event: any) => {
                        onInnerModalFormChange(
                            event.target.value,
                            'EndDateUtc'
                        )
                    }}
                    type="date"
                    value={selectedPlans?.EndDateUtc}
                />
            </div>

            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>

        </div>



    )
}